import { ReactElement } from 'react';

import { appColors } from '@backrs_ui/common-ui/src/assets/appColors';

import { Box, SxProps, Theme } from '@mui/material';

type BackrsUserBadgeProps = Readonly<{
  variant: 'professional' | 'student' | 'provider' | 'foundations';
}>;

export const BackrsUserBadge = ({ variant }: BackrsUserBadgeProps): ReactElement => {
  const getBadgeProps = (userVariant: BackrsUserBadgeProps['variant']) => {
    switch (userVariant) {
      case 'professional':
        return { bgColor: appColors.color.navy3, label: 'B' };
      case 'student':
        return { bgColor: appColors.color.blue1, label: 'S' };
      case 'provider':
        // Provider is the same as Professional, temporarily.
        return { bgColor: appColors.color.navy3, label: 'B' };
      case 'foundations':
        return { bgColor: appColors.color.blue1, label: 'S' };
    }
  };

  const { bgColor, label } = getBadgeProps(variant);

  return (
    <Box
      sx={{
        ...backrsCircleStyle,
        backgroundColor: bgColor,
      }}
    >
      {label}
    </Box>
  );
};

const backrsCircleStyle: SxProps<Theme> = {
  position: 'absolute',
  bottom: '0px',
  right: '0px',
  width: '22px',
  height: '22px',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'white',
  fontSize: '16px',
  fontWeight: 'bold',
  lineHeight: 1,
};
